<template>
  <div class="app-container mt-5">
    <div class="page-title mb-3">
      <router-link to="/configuration">
        <span class="breadcrumb-link">
          <v-icon class="breadcrumb-link-icon">settings</v-icon> Configuration du compte
        </span>
      </router-link>
      <v-icon>keyboard_arrow_right</v-icon>
      <span class="breadcrumb-item">
        <v-icon class="breadcrumb-item-icon">article</v-icon> Mon formulaire de mise à jour
      </span>
    </div>

    <v-card class="p-2 mb-5">
      <v-card-text>
        <h4 class="mb-5">Titre du formulaire</h4>

        <v-text-field
          outlined
          label="Formulaire de validation de vos informations"
          v-model="formTittle"
          hide-details
        ></v-text-field>
      </v-card-text>
    </v-card>

    <v-card class="p-4 mb-5">
      <h4 class="mb-5">Texte d'introduction du formulaire</h4>
      <ckeditor
        :editor="editor"
        v-model="txtIntro"
      ></ckeditor>
    </v-card>

    <v-card
      class="p-4 mb-5"
      id="configuration"
    >
      <h4 class="mb-5">Personnalisation du formulaire</h4>
      <div class="d-flex justify-content-between">
        <div
          style="width: 320px"
          class="position-relative"
        >
          <div class="d-flex gap-10 align-items-end mb-3">
            <h5>Styles</h5>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  @click="resetStyle"
                >
                  <v-icon color="primary">mdi-reload</v-icon>
                </v-btn>
              </template>
              <span>Réinitialiser tous les styles</span>
            </v-tooltip>
          </div>

          <div class="mb-5 valid-button">
            <div class="title-valid-button">Couleurs</div>

            <div class="py-4 pb-0">
              <div class="row">
                <div class="col p-0">
                  <div
                    class="d-flex mb-7 color-editor-div justify-content-center align-items-center flex-column text-center"
                  >
                    <div
                      class="color-editor mb-3"
                      :style="'background-color:' + primaryColor"
                      @click="openColorDialog('primaryColor')"
                    ></div>
                    <v-label>Primaire</v-label>
                  </div>
                </div>
                <div class="col p-0">
                  <div
                    class="d-flex mb-7 color-editor-div justify-content-center align-items-center flex-column text-center"
                  >
                    <div
                      class="color-editor mb-3"
                      :style="'background-color:' + titlesColor"
                      @click="openColorDialog('titlesColor')"
                    ></div>
                    <v-label>Titres</v-label>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div
                    class="d-flex color-editor-div justify-content-center align-items-center flex-column text-center"
                  >
                    <div
                      class="color-editor mb-3"
                      :style="'background-color:' + fieldsColor"
                      @click="openColorDialog('fieldsColor')"
                    ></div>
                    <v-label>Nom des champs</v-label>
                  </div>
                </div>
                <div class="col">
                  <div
                    class="d-flex color-editor-div justify-content-center align-items-center flex-column text-center"
                  >
                    <div
                      class="color-editor mb-3"
                      :style="'background-color:' + backGroundColorRgba"
                      @click="openColorDialog('backGroundColor')"
                    ></div>
                    <v-label>Fond</v-label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex mb-5 color-editor-div">
            <v-select
              :items="availableFonts"
              outlined
              label="Police d'écriture"
              v-model="fontFamily"
              return-object
            >
            </v-select>
          </div>
        </div>

        <div style="width: calc(100% - 350px)">
          <div class="d-flex gap-10 align-items-end mb-5">
            <h5>Prévisualiser</h5>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  @click="preparePreview"
                >
                  <v-icon color="primary">open_in_new</v-icon>
                </v-btn>
              </template>
              <span>Voir le formulaire complet</span>
            </v-tooltip>
          </div>

          <div
            class="web-form-simulation"
            id="pro-layout"
            style="min-height: auto !important"
            :style="'background-color:' + backGroundColorRgba + ';font-family:' + this.fontFamily"
          >
            <div id="pro-cmaj-form">
              <v-alert
                type="info"
                :color="primaryColor"
                v-if="txtIntro !== null"
                class="mb-5 form-container mr-auto ml-auto"
                border="right"
                colored-border
              >
                <div v-html="txtIntro"></div>
              </v-alert>

              <div class="tabulation-title">
                <h5 :style="'color:' + titlesColor">1. Informations générales</h5>
              </div>

              <div class="mt-3">
                <div>
                  <label :style="'color:' + fieldsColor"> Langues parlées </label>
                  <v-autocomplete
                    chips
                    :items="languages"
                    deletable-chips
                    item-text="name"
                    v-model="selectedLanguages"
                    return-object
                    :item-color="primaryColor"
                    multiple
                    outlined
                  >
                    <template #selection="{ item }">
                      <v-chip
                        :color="primaryColor"
                        close
                        @click:close="deleteChip(item, selectedLanguages)"
                      >
                        {{ item.name }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </div>

                <div>
                  <label :style="'color:' + fieldsColor"> Accueil de personnes en situation de handicap </label>
                  <v-radio-group
                    row
                    class="mt-auto mb-auto"
                    value="null"
                    style="padding-top: 0 !important"
                  >
                    <v-radio
                      :color="primaryColor"
                      label="Oui"
                      class="text"
                      :value="true"
                    >
                    </v-radio>
                    <v-radio
                      :color="primaryColor"
                      label="Non"
                      class="text"
                      :value="false"
                    >
                    </v-radio>
                    <v-radio
                      :color="primaryColor"
                      label="Non communiqué"
                      class="text"
                      value="null"
                    >
                    </v-radio>
                  </v-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card>

    <div class="text-right mb-10">
      <v-btn
        class="default-button mt-3"
        @click="saveConfig"
      >
        <v-icon>save</v-icon>
        Enregistrer tout
      </v-btn>
    </div>

    <v-dialog
      v-model="dialogHexa"
      max-width="300px"
      v-if="dialogHexa"
      content-class="color-picker-dialog"
    >
      <v-color-picker
        dot-size="25"
        v-model="currentColor"
        mode="hexa"
        @input="updateColor"
        swatches-max-height="200"
      >
      </v-color-picker>
    </v-dialog>

    <v-dialog
      v-model="dialogRgba"
      max-width="300px"
      v-if="dialogRgba"
      content-class="color-picker-dialog"
    >
      <v-color-picker
        dot-size="25"
        v-model="currentColor"
        mode="rgba"
        @input="updateColor"
        swatches-max-height="200"
      >
      </v-color-picker>
    </v-dialog>
  </div>
</template>

<script>
import ClassicEditor from "../../../plugins/ckeditor"
import { mapMutations, mapState } from "vuex"

export default {
  name: "Forms",
  data() {
    return {
      editor: ClassicEditor,
      txtIntro: null,
      formTittle: null,
      primaryColor: "#1398b5",
      titlesColor: "#000000",
      fieldsColor: "#787d8f",
      backGroundColor: {
        r: 245,
        b: 245,
        g: 245,
        a: 1,
      },
      fontFamily: "Roboto, sans-serif",
      availableFonts: [
        "Arial, sans-serif",
        "Courier New, monospace",
        "Garamond, serif",
        "Georgia, serif",
        "Helvetica, sans-serif",
        "Roboto, sans-serif",
        "Segoe UI",
        "Tahoma, sans-serif",
        "Times New Roman, serif",
        "Trebuchet MS, sans-serif",
        "Verdana, sans-serif",
      ],
      currentColor: null,
      currentProperty: null,
      dialogHexa: false,
      dialogRgba: false,
      languages: [],
      selectedLanguages: [],
      provider: null,
    }
  },
  methods: {
    ...mapMutations("webFormStyle", [
      "setFontFamily",
      "setTitlesColor",
      "setBackGroundColor",
      "setPrimaryColor",
      "setFieldsColor",
    ]),
    saveConfig() {
      let payload = {
        txtIntro: this.txtIntro,
        fontFamily: this.fontFamily,
        primaryColor: this.primaryColor,
        titleColor: this.titlesColor,
        fieldColor: this.fieldsColor,
        backGroundColor: this.backGroundColorRgba,
        formTittle: this.formTittle,
      }

      this.$global.loading = true

      this.$http.post("auth/account/form-config", payload).then((res) => {
        this.$global.loading = false
      })
    },
    openColorDialog(vmProperty) {
      this.currentColor = this[vmProperty]
      this.currentProperty = vmProperty

      if (vmProperty === "backGroundColor") {
        this.dialogRgba = true
      } else {
        this.dialogHexa = true
      }
    },
    deleteChip(itemNeedToRemove, array) {
      for (let i = 0; i < array.length; i += 1) {
        if (array[i].id === itemNeedToRemove.id) {
          array.splice(i, 1)
        }
      }

      this.$forceUpdate()
    },
    updateColor(value) {
      this[this.currentProperty] = value

      if (this.currentProperty === "primaryColor") {
        this.updateChipsColor()
      }
    },
    updateChipsColor() {
      let chips = document.getElementsByClassName("v-chip")

      for (let chip of chips) {
        chip.style.setProperty("background-color", this.primaryColor, "important")
      }
    },
    getLanguages() {
      this.$http.get("resource/languages").then((res) => {
        this.languages = res.body.data.languages

        this.selectedLanguages = this.languages.slice(0, 3)
      })
    },
    resetStyle() {
      this.primaryColor = "#1398b5"
      this.titlesColor = "#000000"
      this.fieldsColor = "#787d8f"
      this.backGroundColor = {
        r: 245,
        b: 245,
        g: 245,
        a: 1,
      }
      this.fontFamily = "Roboto, sans-serif"

      this.updateChipsColor()
    },
    preparePreview() {
      this.setFontFamily(this.fontFamily)
      this.setPrimaryColor(this.primaryColor)
      this.setBackGroundColor(this.backGroundColor)
      this.setFieldsColor(this.fieldsColor)
      this.setTitlesColor(this.titlesColor)

      let route = this.$router.resolve({ path: "/espace-pro/formulaire/" + this.provider.id + "?preview" })

      window.open(route.href, "_blank")
    },
    getFirstAccountProvider() {
      this.$http.get("auth/account/first-provider").then((res) => {
        this.provider = res.body.data.provider
      })
    },
    getWebFormConfig() {
      this.$http.get("auth/account/web-form-config").then((res) => {
        let config = res.body.data.config

        if (config !== null) {
          this.fontFamily = config.font_family
          this.primaryColor = config.primary_color
          this.fieldsColor = config.field_color
          this.titlesColor = config.title_color
          this.backGroundColor = this.rgbaStringToObject(config.background_color)
        }
      })
    },
    rgbaStringToObject(backGroundColor) {
      let colors = ["r", "g", "b", "a"]

      let colorArr = backGroundColor.slice(backGroundColor.indexOf("(") + 1, backGroundColor.indexOf(")")).split(",")

      let obj = {}

      colorArr.forEach((k, i) => {
        obj[colors[i]] = k
      })

      return obj
    },
  },
  computed: {
    ...mapState("account", ["account"]),
    backGroundColorRgba() {
      return (
        "rgba(" +
        this.backGroundColor.r +
        "," +
        this.backGroundColor.g +
        "," +
        this.backGroundColor.b +
        "," +
        this.backGroundColor.a +
        ")"
      )
    },
  },
  created() {
    let txtIntro = this.account.configurations.txtIntro
    let formTittle = this.account.configurations.formTittle

    if (txtIntro !== null) {
      this.txtIntro = txtIntro.value
    }

    if (formTittle !== null) {
      this.formTittle = formTittle.value
    }

    this.getLanguages()
    this.getFirstAccountProvider()
    this.getWebFormConfig()
  },
}
</script>
